import styled from "styled-components";

import BackgroundVideoFile from "../../assets/video/bg_video.mp4";

import BackgroundVideoFileSmall from "../../assets/video/ai_video.mp4";

export default function Header() {
  return (
    <Wrapper id="home">
      <BackgroundVideoDesktop autoPlay loop muted playsInline preload="auto" src={BackgroundVideoFile} />
      <BackgroundVideoMobile autoPlay loop muted playsInline preload="auto" src={BackgroundVideoFileSmall} />

    
    </Wrapper>
  );
}

/* ----------- STYLES ----------- */

const Wrapper = styled.section`
  width: 100%;
  min-height: 100svh;
  height: 100vh;
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);

  @media (max-width: 768px) {
    min-height: 100svh;
    height: 100vh;
  }
`;


const BackgroundVideo = styled.video`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;

  @media (max-width: 768px) {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

const BackgroundVideoDesktop = styled(BackgroundVideo)`
  display: block;
  @media (max-width: 768px) {
    display: none;
  }
`;

const BackgroundVideoMobile = styled(BackgroundVideo)`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;
